import { useT } from '../i18n/LangContext';

const OPTIONS = [
  { code: 'en', badge: 'E', label: 'EN', title: 'Switch to English' },
  { code: 'de', badge: 'G', label: 'DE', title: 'Auf Deutsch wechseln' },
];

export default function LangToggle({ style }) {
  const { lang, setLang } = useT();

  return (
    <div
      className="lang-toggle"
      style={{
        display: 'inline-flex',
        alignItems: 'stretch',
        border: '1px solid #cbd5e1',
        borderRadius: 10,
        overflow: 'hidden',
        fontFamily: 'Arial, sans-serif',
        fontSize: 12,
        fontWeight: 800,
        background: '#ffffff',
        flexShrink: 0,
        ...style,
      }}
    >
      {OPTIONS.map(({ code, badge, label, title }) => {
        const isActive = lang === code;
        return (
          <button
            key={code}
            onClick={() => setLang(code)}
            title={title}
            style={{
              background: isActive ? '#4F46E5' : '#ffffff',
              color: isActive ? '#ffffff' : '#64748b',
              border: 'none',
              padding: '7px 12px',
              cursor: 'pointer',
              fontFamily: 'Arial, sans-serif',
              fontSize: 12,
              fontWeight: 800,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              transition: 'background 0.15s, color 0.15s, transform 0.15s',
              lineHeight: 1,
            }}
          >
            <span
              style={{
                width: 18,
                height: 18,
                borderRadius: 999,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: isActive ? 'rgba(255,255,255,0.16)' : '#eef2ff',
                color: isActive ? '#ffffff' : '#4F46E5',
                fontSize: 11,
                fontWeight: 900,
                letterSpacing: 0.2,
              }}
            >
              {badge}
            </span>
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
